var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-form-input", {
    class: _vm.clases,
    attrs: {
      id: _vm.id,
      name: "input-" + _vm.id,
      "data-cy": "input-" + _vm.id,
      placeholder: _vm.placegolder,
      state: _vm.state,
      "v-validate": _vm.validation,
      disabled: _vm.disabled
    },
    on: {
      blur: function($event) {
        return _vm.onFocus(false)
      },
      focus: function($event) {
        return _vm.onFocus(true)
      }
    },
    model: {
      value: _vm.displayValue,
      callback: function($$v) {
        _vm.displayValue = $$v
      },
      expression: "displayValue"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }